module.exports = __webpack_public_path__ + "img/freekassa-hover.a430820b.png";